module.exports = __webpack_public_path__ + "3059fbd7ff1dd76418c1bb933678e3fb.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_2.png
// module id = 68
// module chunks = 0